import { Color3, Mesh } from 'babylonjs';
import * as Meshes from '../entities/babylon/nodes';

export const MESH: {
  sphere: Meshes.Sphere;
  tube: Meshes.Tube;
  box: Meshes.Box;
  line: Meshes.Line;
  plane: Meshes.Plane;
  cylinder: Meshes.Cylinder;
} = {
  sphere: {
    options: {
      diameter: 0.001,
      segments: 4,
    },
    renderGroupId: 3,
    lodName: 'lodSize',
    lodContainerName: 'lodSpheres',
    defaultName: 'picker_sphere',
  },
  tube: {
    options: {
      sideOrientation: Mesh.DOUBLESIDE,
      updatable: true,
    },
    defaultName: 'tube',
    dragMeshName: 'tube_draggable',
    outerMeshName: 'tube_outer',
    innerMeshName: 'tube_inner',
  },
  box: {
    options: {
      updatable: true,
    },
    defaultName: 'picker_box',
  },
  line: {
    options: {
      updatable: false,
      instance: undefined,
    },
    defaultName: 'lineMesh',
  },
  plane: {
    options: {
      size: 1,
    },
    defaultName: 'planeMesh',
  },
  cylinder: {
    options: {
      diameterTop: 1,
      diameterBottom: 1,
      height: 2,
      tessellation: 24,
    },
    defaultName: 'cylinderMesh',
  },
};

export const MEASUREMENT = {
  lineColor: Color3.FromHexString('#56CCFF'),
  activeLineColor: Color3.FromHexString('#56CCFF'),
  lineRenderGroupId: 2,

  spheresMaterial: Color3.FromHexString('#56CCFF'),
  spheresOptions: {
    diameter: 0.001,
    segments: 4,
  },
  sphereRenderGroupId: 3,

  imageUrl: '../assets/img/red-ball.png',
  imageWidth: '5px',
  imageHeight: '5px',
};

const SPHERE_CONFIG = {
  color: Color3.FromHexString('#56CCFF'),
  sphereOptions: {
    diameter: 0.01,
    segments: 4,
  },
  sphereRenderGroupId: 3,
  lodName: 'lodSize',
  lodContainerName: 'lodSpheres',
};

export const DROP_LINE = {
  ...SPHERE_CONFIG,
  lineRenderGroupId: 2,
  name: 'dropLineSphere',
  lineName: 'dropLineLine',
};

export const CUBOID_MAPPING = {
  name: 'cuboid',
};

export const COORDINATES_LAYER = {
  ...SPHERE_CONFIG,
  name: 'coordinatesLayerSphere',
};

export const MEASUREMENT_PRECISION = {
  precision: 0.1,
};

export const MEASUREMENT_SPHERES_NAMES = {
  MIDDLE_SPHERE_NAME: 'middle_sphere',
  PICKER_SPHERE_NAME: 'picker_sphere',
  LOD_SPHERE_NAME: 'sphere_lod_',
  LOD_SPHERES_NAME: 'lod_spheres',
  LINE_NAME: 'measurement_line',
};

export const LOD_SPHERES_CONFIG = {
  diameterStart: 0.01,
  diameterEnd: 0.1,
  spheresAmount: 12,
  segments: 10,
  LOD_POWER: 1.1,
};

export const LOD_MESHES_CONFIG = {
  boxSizeStart: 0.3,
  sizeStart: 0.01,
  sizeEnd: 0.05,
  boxesAmount: 12,
  LOD_POWER: 1.1,
};

export const CAMERA_MESH_VERTEX = [
  [0.05, -0.05, 0.05],
  [-0.05, -0.05, 0.05],
  [-0.05, 0.05, 0.05],
  [0.05, 0.05, 0.05],
  [0.25, -0.25, -0.25],
  [-0.25, -0.25, -0.25],
  [-0.25, 0.25, -0.25],
  [0.25, 0.25, -0.25],
];

export const CAMERA_MESH_FACE = [
  [0, 1, 2, 3],
  [4, 7, 6, 5],
  [1, 5, 6, 2],
  [0, 3, 7, 4],
  [0, 4, 5, 1],
  [3, 2, 6, 7],
];

export const BABYLON_COLORS = {
  BLACK: 'Black',
  WHITE: 'White',
};
